module.exports = __webpack_public_path__ + "media/images/design/images/h2_disaster-2878c512f8619b8d6aaaea52dce20e34.png";